<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
//import forminput from "../formcomponet/forminput.vue";
import draggable from "vuedraggable";
import { uuid } from "vue-uuid";
import Eye from "./eye.vue";
export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Modül Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    Eye,
    draggable,
    // forminput
  },
  data() {
    return {
      title: this.$t("homepageblocks.Title"),
      items: [
        {
          text: this.$t("homepageblocks.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("homepageblocks.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("homepageblocks.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      },
      FormData: {},
      Data:{},
      DataUpdate: "",
      enabled: true,
      SiteJson: [],
      ColJson: [
        { name: "Col-1", col: "col-1", id: uuid.v4(), child: [] },
        { name: "Col-2", col: "col-2", id: uuid.v4(), child: [] },
        { name: "Col-3", col: "col-3", id: uuid.v4(), child: [] },
        { name: "Col-4", col: "col-4", id: uuid.v4(), child: [] },
        { name: "Col-5", col: "col-5", id: uuid.v4(), child: [] },
        { name: "Col-6", col: "col-6", id: uuid.v4(), child: [] },
        { name: "Col-7", col: "col-7", id: uuid.v4(), child: [] },
        { name: "Col-8", col: "col-8", id: uuid.v4(), child: [] },
        { name: "Col-9", col: "col-9", id: uuid.v4(), child: [] },
        { name: "Col-10", col: "col-10", id: uuid.v4(), child: [] },
        { name: "Col-11", col: "col-11", id: uuid.v4(), child: [] },
        { name: "Col-12", col: "col-12", id: uuid.v4(), child: [] },
      ],
      ChildJson: [],
      ComboCol: [
        { name: "Col-1", col: "col-1" },
        { name: "Col-2", col: "col-2" },
        { name: "Col-3", col: "col-3" },
        { name: "Col-4", col: "col-4" },
        { name: "Col-5", col: "col-5" },
        { name: "Col-6", col: "col-6" },
        { name: "Col-7", col: "col-7" },
        { name: "Col-8", col: "col-8" },
        { name: "Col-9", col: "col-9" },
        { name: "Col-10", col: "col-10" },
        { name: "Col-11", col: "col-11" },
        { name: "Col-12", col: "col-12" },
      ],
      Eye: false,
    };
  },
  methods: {
    Get() {
      
     
    },
 
    Websitepost(){
      var Data = this.Data
           Data.Sitejson = JSON.stringify(this.SiteJson)
    
      this.Update("website", Data).then();
    },
    UuidChenge(event) {
      this.ColJson.push({
        name: event.removed.element.name,
        col: event.removed.element.col,
        id: uuid.v4(),
        child: [],
      });
    },
    UuidChengeNesneler(event) {
      this.ChildJson.push({
        name: event.removed.element.name,
        id: uuid.v4(),
        col: "col-12",
      });
    },
  },
  created(){
     this.ActionsFilterGet({
        Service: "homepageblocks",
        Page: this.Page,
        Filter: "&Asc=Dataorder",
      }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
          this.ChildJson.push({
            name: res.Data[i].Title,
            id: res.Data[i].Id,
            col: "col-12",
          });
          this.FormData = res.Data;
        }
      });
      this.ActionsSingleGet({
        Service: "website",
        Id: window.$cookies.get("website")
      }).then((res) => {
        if(res){
            this.Data=res.Data;
          if(res.Data.Sitejson){
          this.SiteJson = JSON.parse(res.Data.Sitejson)
          }
        }
      });
  }
};
</script>
  
<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">   
        <div class="col-xl-12">
          <div class="row mb-2">
            <div class="col-sm-12">
              <div class="text-sm-end">
                <button
                  type="button"
                  class="btn btn-success btn-rounded mb-2 me-2"
                  v-b-modal.homepageblocks
                  @click="Eye = true"
                >
                  <i class="mdi mdi-eye me-1"></i
                  >{{ $t("homepageblocks.Page.Onizleme") }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-rounded mb-2 me-2"
                  @click="Websitepost()"
                >
                  <i class="mdi mdi-content-save-all me-1"></i
                  >{{ $t("homepageblocks.Page.Kaydet") }}
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="
                col-md-8
                p-3
                bg-secondary
                text-white
                border border-white
                rounded-3
              "
            >
              <h5 class="text-center text-white">Site Tasarımı</h5>
        
              <draggable
                class="dragArea row p-2"
                :list="SiteJson"
                group="col"
                :clone="cloneDog"
                @change="log"
              >
                <template v-for="(element, index) in SiteJson">
                  <div :key="index" :class="element.col">
                    <div
                      class="
                        list-group-item
                        mb-3
                        bg-success
                        border border-success
                        rounded-3
                      "
                    >
                      <h5>{{ element.name }}</h5>

                      <button
                        class="btn-close position-absolute top-0 end-0"
                        @click="SiteJson.splice(index, 1)"
                      ></button>
                      <draggable
                        class="row"
                        :list="element.child"
                        group="child"
                        :clone="cloneDog"
                        @change="log"
                      >
                        <template v-for="(child, childindex) in element.child">
                          <div :class="child.col" :key="childindex">
                            <div
                              class="
                                list-group-item
                                mb-2
                                bg-white
                                border border-white
                                rounded-3
                              "
                            >
                              <div class="row">
                                <div class="col-md-7 p-0">
                                  {{ child.name }}
                                </div>
                                <div class="col-md-5 p-0">
                                  <select
                                    v-model="child.col"
                                    class="form-select col-md-12"
                                    type="text"
                                  >
                                    <option
                                      v-for="Data in ComboCol"
                                      :key="Data.col"
                                      :value="Data.col"
                                      :selected="child.col"
                                    >
                                      {{ Data.name }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <button
                                class="btn-close position-absolute top-0 end-0"
                                @click="
                                  SiteJson[index].child.splice(childindex, 1)
                                "
                              ></button>
                            </div>
                          </div>
                        </template>
                      </draggable>
                    </div></div
                ></template>
              </draggable>
            </div>

            <div class="col-md-4">
              <div class="row">
                <div
                  class="col-12 p-3 bg-secondary border border-white rounded-3"
                >
                  <h5 class="text-center text-white">Eklenebilecek Kolonlar</h5>
                  <draggable
                    class="dragArea row"
                    :list="ColJson"
                    group="col"
                    :clone="cloneDog"
                    @change="UuidChenge($event)"
                  >
                    <div
                      class="col-4 mt-2"
                      v-for="(element, index) in ColJson"
                      :key="index"
                    >
                      <div
                        class="
                          list-group-item
                          bg-success
                          border border-white
                          rounded-3
                        "
                      >
                        {{ element.name }}
                      </div>
                    </div>
                  </draggable>
                </div>

                <div
                  class="col-12 p-3 bg-secondary border border-white rounded-3"
                >
                  <h5 class="text-center text-white">Eklenebilecek Nesneler</h5>
                  <draggable
                    class="dragArea row"
                    :list="ChildJson"
                    group="child"
                    :clone="cloneDog"
                    @change="UuidChengeNesneler($event)"
                  >
                    <div
                      class="
                        list-group-item
                        m-1
                        col-5
                        border border-white
                        rounded-3
                      "
                      v-for="element in ChildJson"
                      :key="element.id"
                    >
                      {{ element.name }}
                    </div>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
      
        <Eye v-if="Eye" :SiteJson="SiteJson" />
      </div>
    </Layout>
  </Loader>
</template>
